import { ADDITIONAL_FUNCTIONALITY, CONTENT_SECTION_TYPES, CONTENT_TYPE, emptyLatexValue, PERMISSION_CONTENT_TYPES, PERMISSION_QUESTION_CONTENT_TYPES, PERMISSION_TEST_CONTENT_TYPES, QUESTION_TYPES, TEST_TEMPLATE_CONFIG, USER_RIGHTS, USER_TYPE } from "../constants/comman";
import { statusType } from "../components/mylibrary/types/ContentInSection";
import _ from "lodash";
import moment from "moment";
import { GoalLevel } from "../components/goal-management/types/GoalLevel";
import {
  QuestionBenchmarkItem,
  QuestionBenchmarkError,
} from "../components/mylibrary/types/Benchmarks";
import ContentData, { SolutionStep, StepWiseSolution } from "../components/mylibrary/types/ContentData";
import { SubSection, TestTemplateBody } from '../components/test-template/types/TestTemplateBody';
import config from "../config/config";
import { CHANGE_LABEL, DATE_PARAMS } from "../components/course-Management/Constants/constants";
import ACLService from "../components/acl/services/aclService";

export const CONTENT_ID_KEY = "contentId";

export const setContentId = (contentId: string) => {
  localStorage.setItem(CONTENT_ID_KEY, contentId);
};

export const getContentId = () => {
  return localStorage.getItem(CONTENT_ID_KEY);
};

export const getClientId = () => {
  let store: any = localStorage.getItem("patmy");
  store = JSON.parse(store);
  const clientId = store.authenticatedUser.clientId._id;
  return clientId;
};

export const removeContentId = () => {
  return localStorage.removeItem(CONTENT_ID_KEY);
};

/**
 * @parser HTML function parser
 * const isHTML = (str: string): boolean => {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
 *  */

export const isHTML = (str: string): boolean => {
  return str.toLowerCase().includes("[object htmldivelement]");
};

export const convertCamelCaseToText = function (camelCaseText: string) {
  if (camelCaseText === 'addDifficultySkills') {
    return 'Add Difficulty & Skills';
  }
  const result = camelCaseText.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const validateTitle = function (validationsCopy: any, title: string) {
  if (title.trim().length > 0 && !emptyLatexValue.includes(title)) {
    validationsCopy.questionContent.status = statusType.success;
  } else {
    validationsCopy.questionContent.status = statusType.warning;
  }
  return validationsCopy;
};

export const validateOptions = function (
  validationsCopy: any,
  data: any
) {

  const { optionContent: { subType, options }, optionSettings } = data;
  let status = statusType.success;
  if (optionSettings && !optionSettings.displayCount && subType !== QUESTION_TYPES.TRUE_FALSE.toString()) {
    status = statusType.warning;
  }
  validationsCopy.optionsContent.type = 'optionSettings'
  validationsCopy.optionsContent.status = status;
  if (status === statusType.warning) {
    return validationsCopy;
  }

  switch (subType) {
    case "0":
      options.forEach((o: any) => {
        if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
          status = statusType.warning;
        }
      });
      validationsCopy.optionsContent.status = status;
      validationsCopy.optionsContent.type = 'options'
      return validationsCopy;
    case "8":
      options.forEach((o: any) => {
        if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
          status = statusType.warning;
        }
      });
      validationsCopy.optionsContent.status = status;
      validationsCopy.optionsContent.type = 'options'
      return validationsCopy;
    case "2":
      options.forEach((o: any) => {
        if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
          status = statusType.warning;
        }
      });
      validationsCopy.optionsContent.status = status;
      validationsCopy.optionsContent.type = 'options'
      return validationsCopy;
    case "1":
      const { optionLeft, optionRight } = options;
      optionLeft.forEach((o: any) => {
        if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
          status = statusType.warning;
        }
      });
      optionRight.forEach((o: any) => {
        if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
          status = statusType.warning;
        }
      });
      validationsCopy.optionsContent.status = status;
      validationsCopy.optionsContent.type = 'options'
      return validationsCopy;
    default:
      return validationsCopy;
  }
};

export const validateAnswer = function (
  validationsCopy: any,
  answer: any,
  subType: string,
  optionSettings?: any
) {
  const data = _.get(answer, "data") || [];
  let status = statusType.warning;

  switch (subType) {
    case "0":
      validationsCopy.correctAnswer.status =
        data.length > 0 ? statusType.success : statusType.warning;
      return validationsCopy;
    case "2":
      validationsCopy.correctAnswer.status =
        data.length > 0 ? statusType.success : statusType.warning;
      return validationsCopy;
    case "7":
      validationsCopy.correctAnswer.status =
        data.length > 0 ? statusType.success : statusType.warning;
      return validationsCopy;
    case "8":
      validationsCopy.correctAnswer.status =
        data.length > 0 ? statusType.success : statusType.warning;
      return validationsCopy;
    case "1":


      data.forEach((d: any) => {
        if (d.value && d.value.length > 0) {
          status = statusType.success;
        }
      });
      if (data.length < 4) {
        status = statusType.warning;
      }
      validationsCopy.correctAnswer.status = status;
      return validationsCopy;
    case "3":
      let isValid = true;
      if(!Array.isArray(answer)){
        answer = answer.data;
      }
      (answer || []).forEach((el:any) => (isValid = !el.error && isValid));
      if ((data && data[0] && data[0].value && data[0].weightage) || isValid) {
        status = statusType.success;
      }
      validationsCopy && ((validationsCopy.correctAnswer || {}).status = status);
      return validationsCopy;
    case "4":
      if (data && data[0] && data[0].value) {
        status = statusType.success;
      }
      (validationsCopy.correctAnswer || {}).status = status;
      return validationsCopy;
    case "6":
      if (data && data[0] && data[0].value !== '' && data[0].value !== undefined) {
        status = statusType.success;
      }
      validationsCopy.correctAnswer.status = status;
      return validationsCopy;
    default:
      return validationsCopy;
  }
};

export const validateSyllabus = function (
  validationsCopy: any,
  syllabus: any[],
  isConceptAvailable = true,
) {
  validationsCopy.mapSyllabus.status =
    syllabus.length > 0 ? statusType.success : statusType.warning;
  if(!isConceptAvailable){
    validationsCopy.mapSyllabus.status = statusType.warning
  }
  return validationsCopy;
};

export const validateQuestionHint = function (
  validationsCopy: any,
  hints: string
) {
  if ('questionHints' in validationsCopy) {
    if (hints.trim().length > 0 && !emptyLatexValue.includes(hints)) {
      validationsCopy.questionHints.status = statusType.success;
    } else {
      validationsCopy.questionHints.status = statusType.warning;
    }
  }
  return validationsCopy;
};

export const validateBenchmarks = function (
  validationsCopy: any,
  benchmarks: any,
) {
  if ('addBenchmarking' in (validationsCopy || {})) {
    validationsCopy.addBenchmarking.status = statusType.success;
    benchmarks.forEach((benchmark: any) => {
      const { course, goalLevel, isDeleted } = benchmark;
      const isValidBenchMark = course.id && goalLevel.id;
      if (!isValidBenchMark && !isDeleted) {
        validationsCopy.addBenchmarking.status = statusType.warning;
      }
    });
  }
  return validationsCopy;
};

export const validateDifficultyAndSkillLevel = function (validationsCopy: any, value: any) {
  if (validationsCopy) {
    validationsCopy['addDifficultySkills'].status = (value.isDifficultyLevelPresent && value.isDifficultyTypePresent) ? statusType.success : statusType.warning;
  }
  return validationsCopy;
}

export const validateSolutionStep = function (
  solutionStep: string
) {
  if (solutionStep.trim().length > 0 && !emptyLatexValue.includes(solutionStep)) {
    // validationsCopy.solutionContent.status = statusType.success;
    return true;
  }
  return false;
};

export const validateStepWiseSolutions = (validationsCopy: any, solutions: StepWiseSolution[], validateWeightage = false) => {
  for (let { solutionSteps } of solutions) {
    let weightageForAllSteps = 0;
    if (!solutionSteps || !solutionSteps.length) {
      validationsCopy.solutions.status = statusType.warning;
      validationsCopy.solutions.type = 'step';
      return validationsCopy;
    }
    for (let step of solutionSteps) {
      const { weightage, solution } = step;
      if (weightage && !isNaN(parseInt(weightage.toString()))) {
        weightageForAllSteps += parseInt(weightage.toString());
      } else if (validateWeightage) {
        validationsCopy.solutions.status = statusType.warning;
        validationsCopy.solutions.type = 'weightage';
        validationsCopy.solutions.isEmptyWeightage = true;
        return validationsCopy;
      }
      if (!validateSolutionStep(solution)) {
        validationsCopy.solutions.status = statusType.warning;
        validationsCopy.solutions.type = 'step';
        return validationsCopy;
      }
    }

    if (validateWeightage && weightageForAllSteps !== 100) {
      validationsCopy.solutions.status = statusType.warning;
      validationsCopy.solutions.type = 'weightage';
      validationsCopy.solutions.isEmptyWeightage = false;
      return validationsCopy;
    }
  }
  validationsCopy.solutions.status = statusType.success;
  validationsCopy.solutions.type = 'step';
  return validationsCopy;
}

export const validateTags = function (
  validationsCopy: any,
  tagsList: any[],
  tags: any[]
) {
  let requiredCount = 0;
  let requiredMeet = 0;
  tagsList.forEach((t) => {
    if (t.isCompulsory) {
      requiredCount++;
      if (tags && tags.length > 0) {
        tags.forEach((pt: any) => {
          if (pt.relation && pt.relation.id && t._id == pt.relation.id) {
            if (pt.values && pt.values[0]) {
              requiredMeet++;
            }
          }
        });
      }
    }
  });

  let status =
    requiredCount != requiredMeet ? statusType.warning : statusType.success;
  if (validationsCopy && validationsCopy.addTags) {
    validationsCopy.addTags.status = status;
  }

  return validationsCopy;
};

export const getContentSubTypeCode = (code: any) => {
  let contentSubTypeCode = "";
  try {
    contentSubTypeCode = code.toString();
  } catch (e) {
    contentSubTypeCode = "";
  }
  return contentSubTypeCode;
};

export const convertSubjectIdFromObjectToString = (subjects: any) => {
  //subjects key subject id from object to string id
  let conceptIds: any[] = [];
  let conceptCodes: any[] = [];
  if (!_.isEmpty(subjects)) {
    // let newSubjects: any[] = [];
    _.forEach(subjects, (s, sI: number) => {
      if (!s.subjectId) {
        return
      }
      if (s.subjectId.checked) {
        s.checked = true
      }
      s['chapters'] = [];
      s.subjectId = s.subjectId._id;
      _.forEach(s.subSubjects, (ss: any, ssI: number) => {
        if (!ss.subSubjectId) {
          return
        }
        if (ss.subSubjectId && ss.subSubjectId._id) {
          if (ss.subSubjectId.checked) {
            ss.checked = true
          }
          ss.subSubjectId = ss.subSubjectId._id;
          _.forEach(ss.chapters, (ch: any, chI: number) => {
            if (!ch.chapterId) {
              return
            }
            if (ch.chapterId.checked) {
              ch.checked = true
            }
            ch.chapterId = ch.chapterId._id;
            s['chapters'].push(ch);
            _.forEach(ch.concepts, (co: any, coI: number) => {
              if (!co.conceptId) {
                return
              }
              conceptIds.push(co.conceptId._id);
              conceptCodes.push(co.conceptCode);
              if (co.conceptId.checked) {
                co.checked = true
              }
              co.conceptId = _.get(co, 'conceptId._id');
              co.classId = _.get(co, 'classId._id');
            })
          })
        }
      })
    });
  }
  return { conceptIds, conceptCodes }
}

export const convertSubjectWithId = function (
  subjects: any,
  conceptIds: any,
  conceptCodes: any
) {
  if (!_.isEmpty(subjects)) {
    _.forEach(subjects, (s, sI: number) => {
      if (!s.subjectId) {
        return;
      }
      if (s.subjectId.checked) {
        s.checked = true;
      }
      s.subjectId = s.subjectId._id || s.subjectId;
      _.forEach(s.subSubjects, (ss: any, ssI: number) => {
        if (!ss.subSubjectId) {
          return;
        }
        if (ss.subSubjectId) {
          if (ss.subSubjectId.checked) {
            ss.checked = true;
          }
          ss.subSubjectId = ss.subSubjectId._id || ss.subSubjectId;
          _.forEach(ss.chapters, (ch: any, chI: number) => {
            if (!ch.chapterId) {
              return;
            }
            if (ch.chapterId.checked) {
              ch.checked = true;
            }
            ch.chapterId = ch.chapterId._id || ch.chapterId;
            // if (!s['chapters']) {
            s["chapters"] = [];
            // }
            s["chapters"].push(ch);
            _.forEach(ch.concepts, (co: any, coI: number) => {
              if (!co.conceptId) {
                return;
              }
              conceptIds.push(co.conceptId._id || co.conceptId);
              conceptCodes.push(co.conceptCode);
              if (co.conceptId.checked) {
                co.checked = true;
              }
              co.conceptId = co.conceptId._id || co.conceptId;
              co.classId = co.classId._id || co.classId;
            });
          });
        }
      });
    });
  }
};

export const serialize = function (obj: any) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export const getDiffOnTwoDates = function (startDate: any, endDate: any) {
  const a = moment(startDate);
  const b = moment(endDate);
  return b.diff(a, "days"); // 1
};

export const validateEmail = function (email: true) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
/*
 *
 */
export const isEqualObjects = (a: Object, b: Object) => {
  return JSON.stringify(a) === JSON.stringify(b)
}
export const checkIsConceptAndChapterChange = (
  subjects: any,
  secondarySubjects: any,
  originalSubjects: any,
  originalSecondarySubjects: any
) => {
  return !isEqualObjects(subjects, originalSubjects)
    || !isEqualObjects(secondarySubjects, originalSecondarySubjects)
}

export const isEmptyList = (list: any[]) => {
  return !list || !list.length;
}

export const checkIsDifficultyAndSkillChange = (
  difficultyLevel: [],
  difficultyType: [],
  originalDifficultyLevel: [],
  originalDifficultyType: []
) => {

  const emptyState = isEmptyList(difficultyLevel) || isEmptyList(difficultyType) ||
    isEmptyList(originalDifficultyLevel) || isEmptyList(originalDifficultyType);

  if (emptyState) {
    return false;
  }

  return !isEqualObjects(difficultyLevel, originalDifficultyLevel)
    || !isEqualObjects(difficultyType, originalDifficultyType)
}
export const checkIsCorrectAnswerChange = function (
  defaultCorrectAnswer: any,
  correctAnswer: any
) {
  let _defaultCorrectAnswer: any = { data: [] };
  const defaultCorrectAnswerTemp = JSON.parse(
    JSON.stringify(defaultCorrectAnswer)
  );
  if (!!defaultCorrectAnswerTemp.data) {
    _defaultCorrectAnswer = defaultCorrectAnswerTemp;
  }
  else {
    _defaultCorrectAnswer.data = defaultCorrectAnswerTemp;
  }
  let _correctAnswer = JSON.parse(JSON.stringify(correctAnswer));
  // Commenting because of requirement of AD-3242
  // try {
  //   _defaultCorrectAnswer.data = _defaultCorrectAnswer.data.map((obj: any) => {
  //     return obj.value;
  //   });
  //   _correctAnswer.data = _correctAnswer.data.map((obj: any) => {
  //     return obj.value;
  //   });
  // }
  // catch{ }
  return _.isEqual(_defaultCorrectAnswer, _correctAnswer);
};

export const isAddToQueueChangesActive = function (
  defaultCorrectAnswer: any,
  correctAnswer: any,
  alternateAnswer: boolean
) {
  return (
    !checkIsCorrectAnswerChange(defaultCorrectAnswer, correctAnswer) ||
    alternateAnswer
  );
};

export const getParagraphUpdatedIndex = function (
  defaultCorrectAnswer: any,
  correctAnswer: any
) {
  let result:any = [];
  const _defaultCorrectAnswer = JSON.parse(
    JSON.stringify(defaultCorrectAnswer)
  );
  const _correctAnswer = JSON.parse(JSON.stringify(correctAnswer));
  for (let i = 0, len = _correctAnswer.length; i < len; i++){
    if (!_.isEqual(_correctAnswer[i].data, _defaultCorrectAnswer[i].data)){
      result.push(i)
    }
   }
return result
};

export const checkIsCorrectAnswerChangeParagraph = function (
  defaultCorrectAnswer: any,
  correctAnswer: any
) {
  const _defaultCorrectAnswer = JSON.parse(
    JSON.stringify(defaultCorrectAnswer)
  );
  const _correctAnswer = JSON.parse(JSON.stringify(correctAnswer));
  return _.isEqual(_defaultCorrectAnswer, _correctAnswer);
};

export const isAddToQueueChangesActiveParagraph = function (
  defaultCorrectAnswer: any,
  correctAnswer: any,
  alternateAnswer: boolean
) {
  return (
    !checkIsCorrectAnswerChangeParagraph(defaultCorrectAnswer, correctAnswer) ||
    alternateAnswer
  );
};
export interface isConceptAndChapterAddToQueueModeActiveInterface {
  subjects: any;
  secondarySubjects: any;
  originalSubjects: any;
  originalSecondarySubjects: any;
}
export const isConceptAndChapterAddToQueueModeActive = (
  data: isConceptAndChapterAddToQueueModeActiveInterface
) => {
  const {
    subjects,
    secondarySubjects,
    originalSubjects,
    originalSecondarySubjects
  } = data
  return checkIsConceptAndChapterChange(
    subjects,
    secondarySubjects,
    originalSubjects,
    originalSecondarySubjects
  )
}
export interface isDifficultyAndSkillAddToQueueModeActiveInterface {
  difficultyLevel: any;
  difficultyType: any;
  originalDifficultyLevel: any;
  originalDifficultyType: any;
}
export const isDifficultyAndSkillAddToQueueModeActive = (
  data: isDifficultyAndSkillAddToQueueModeActiveInterface
) => {
  const {
    difficultyLevel,
    difficultyType,
    originalDifficultyLevel,
    originalDifficultyType
  } = data
  return checkIsDifficultyAndSkillChange(
    difficultyLevel,
    difficultyType,
    originalDifficultyLevel,
    originalDifficultyType
  )
}
export interface isQuestionAddToQueueModeActiveInterface {
  isValidAttempts: boolean;
  correctAnswer: any;
  defaultCorrectAnswer: any;
  alternateAnswer: boolean;
}
export const isQuestionAddToQueueModeActive = function (
  data: isQuestionAddToQueueModeActiveInterface
) {
  const {
    isValidAttempts,
    correctAnswer,
    defaultCorrectAnswer,
    alternateAnswer,
  } = data;
  return (
    isValidAttempts &&
    isAddToQueueChangesActive(
      correctAnswer,
      defaultCorrectAnswer,
      alternateAnswer
    )
  );
};

export const isQuestionAddToQueueModeActiveParagraph = function (
  data: isQuestionAddToQueueModeActiveInterface
) {
  const {
    isValidAttempts,
    correctAnswer,
    defaultCorrectAnswer,
    alternateAnswer,
  } = data;
  return (
    isValidAttempts &&
    isAddToQueueChangesActiveParagraph(
      correctAnswer,
      defaultCorrectAnswer,
      alternateAnswer
    )
  );
};

export const calCulateProgressBar = function (validations: any, content?: any) {
  const progressBarSetting: any = {};
  let sucess = 0;
  let total = 0;



  validations &&
    Object.keys(validations).forEach((key: any) => {
      if (key === 'questionHints') {
        if (content) {
          if (content.content.mandatoryFields == undefined) {
            total -= 1;
          }
        }
      }
      total += 1;
      if (validations[key].status == statusType.success) {
        if (key === 'questionHints') {
          if (content) {

            if (content.content.mandatoryFields == undefined) {
              sucess -= 1;
            }
          }
        }
        sucess += 1;
      }
    });



  progressBarSetting.barPercentage = ((sucess / total) * 100).toFixed(2);
  // TODO - looking like we can remove bar length in future
  progressBarSetting.barLength = parseInt(progressBarSetting.barPercentage);
  return progressBarSetting;
  // this.props.completionPercent(this.props.formData, progressBarSetting.barLength);
};

export const onlyAllowNumbers = (evt: any) => {
  let theEvent = evt;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);

  let regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};

export function extractContent(s: string) {
  var span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

export const validateGoalLevels = (goalLevels: GoalLevel[]) => {
  if (!goalLevels || goalLevels.length === 0) {
    return { hasError: false, errors: [] };
  }

  const goalLevelNameSet = new Set();
  const goalLevelScaleSet = new Set();
  let prevLevelMinimum = -1;
  let prevLevelMaximum = -1;
  let hasError = false;

  const levelNameErrors = goalLevels.map(({ name, scale }) => {
    let errors = [];
    if (!name && scale > 0) {
      errors.push("Please enter a goal level");
    }
    if (!name) {
      return errors;
    }
    name = name.trim();

    const validationErrors = validateAll(
      [
        {
          validator: (val: string) => val.length >= 3,
          errorMessage: "Please enter a value which has atleast 3 characters",
        },
        {
          validator: (val: string) => {
            const regex = /^[a-zA-Z0-9].+[a-zA-Z0-9]$/; // Checks if minimum 3 characters and doesn't start or end with special characters
            return regex.test(val);
          },
          errorMessage:
            "Please enter a value which doesn’t have special character at the beginning or at the end",
        },
        {
          validator: (val: string) =>
            !checkIfValidForInorderCheck(val) ||
            checkIfSplittedLevelValuesInOrder(val),
          errorMessage:
            "The value before hyphen(-) should be less than value after hyphen",
        },
      ],
      name,
      true
    );

    errors = errors.concat(validationErrors);

    if (!errors.length && goalLevelNameSet.has(name)) {
      // check if level is duplicate
      errors.push("The entered value already exists");
    } else if (!errors.length) {
      goalLevelNameSet.add(name);
    }

    if (!errors.length && checkIfValidForInorderCheck(name)) {
      const [minimum, maximum] = name.split("-").map((val) => parseInt(val));
      if (
        (prevLevelMaximum === -1 && prevLevelMinimum === -1) ||
        !checkIfOverlaps(prevLevelMinimum, prevLevelMaximum, minimum, maximum)
      ) {
        prevLevelMaximum = maximum;
        prevLevelMinimum = minimum;
      } else {
        errors.push(
          "The value should not overlap with the range of any other goal level"
        );
      }
    }

    return errors;
  });

  const levelScaleErrors = goalLevels.map(({ name, scale }) => {
    let errors = [];

    if (name && (scale === 0 || scale === "")) {
      errors.push("Please enter a value between 1 and 100");
    }

    if (!scale) {
      return errors;
    }

    const validationErrors = validateAll(
      [
        {
          validator: (val: number) => _.inRange(val, 1, 101),
          errorMessage: "Please enter a value between 1 and 100",
        },
      ],
      scale,
      true
    );

    errors = errors.concat(validationErrors);

    // check if scale is duplicate
    if (goalLevelScaleSet.has(scale)) {
      errors.push("The entered value already exists");
    } else {
      goalLevelScaleSet.add(scale);
    }
    return errors;
  });

  const combinedErrors = levelNameErrors.map((name, index) => {
    const scale = levelScaleErrors[index];

    hasError = hasError || name.length > 0 || scale.length > 0;
    return { name, scale };
  });

  return { hasError, errors: combinedErrors };
};

function checkIfSplittedLevelValuesInOrder(value: string) {
  const parsed = value.split("-").map((val) => parseInt(val));
  const areInOrder = checkIfInAscendingOrder(parsed);
  if (areInOrder) {
    return true;
  }
  return false;
}

function checkIfValidForInorderCheck(value: string) {
  const splitted = value.split("-");
  if (splitted.length !== 2) {
    return false;
  }
  const parsed = splitted.map((val) => parseInt(val));
  const areNaturalNumbers = parsed.every(
    (parsedVal) => !isNaN(parsedVal) && parsedVal >= 0
  );
  if (!areNaturalNumbers) {
    return false;
  }
  return true;
}

function checkIfInAscendingOrder(arr: number[]) {
  if (arr.length === 0) {
    return true;
  }
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] < arr[i - 1]) {
      return false;
    }
  }
  return true;
}

function checkIfOverlaps(x1: number, y1: number, x2: number, y2: number) {
  if (_.inRange(x2, x1, y1 + 1) || _.inRange(y2, x1, y1 + 1)) {
    return true;
  }
  return false;
}

interface Validations {
  validator: (value: any) => boolean;
  errorMessage: string;
}
export const JEE_MAIN_COURSE_ID = '5ace202e9fe7b01d5806bb69';
export const OPTIONAL_SUPPORTED_COURSE_IDS = [JEE_MAIN_COURSE_ID, '5ace202e9fe7b01d5806bb6a'];

export function validateAll(
  validations: Validations[],
  value: any,
  stopAfterFirstFailure = false
) {
  const errors = [];
  for (let validation of validations) {
    const { validator, errorMessage } = validation;
    const isValid = validator(value);
    if (!isValid) {
      errors.push(errorMessage);
    }
    if (!isValid && stopAfterFirstFailure) {
      return errors;
    }
  }
  return errors;
}

export const toShowJEEMainSpecificFields = (template: TestTemplateBody) => {
  const { courseId } = template;
  return courseId === JEE_MAIN_COURSE_ID && (!template._id || _.get(template, 'sections[0].subSection[0].mandatoryQuestionCount', undefined) !== undefined)
}

export const getNoOfQuestionsToConsiderForMarks = (subSection: SubSection) => {
  const { mandatoryQuestionCount, noOfQuestions, optionalQuestions } = subSection
  return optionalQuestions && mandatoryQuestionCount !== undefined ? mandatoryQuestionCount || 0 : noOfQuestions;
}
export const getMandatoryQuestionCount = (template: TestTemplateBody) => {
  return template && template.sections && template.sections.reduce((total, { subSection }) => {
    const subSectionTotal = subSection.reduce((acc, { mandatoryQuestionCount, noOfQuestions = 0 }) => acc + (mandatoryQuestionCount === undefined ? noOfQuestions : mandatoryQuestionCount), 0)
    return total + subSectionTotal;
  }, 0)
}

export function checkIfSpecialCharacter(char: string) {
  const specialCharacters = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialCharacters.test(char);
}

export function validateQuestionBenchmarks(
  benchmarks: QuestionBenchmarkItem[],
  { forceCourse } = { forceCourse: false }
) {

  return benchmarks.reduce(
    (
      acc: { hasErrors: boolean; errors: QuestionBenchmarkError[] },
      benchmark
    ) => {
      const { goalLevel, course } = benchmark;
      const error: QuestionBenchmarkError = {
        course: "",
        goalLevel: "",
      };
      if (forceCourse && !course.name) {
        error.course = "Please select one value";
      }
      if (
        !!course.name
        &&
        !goalLevel.name) {
        error.goalLevel = "Please select one value";
      }

      acc.hasErrors = acc.hasErrors || !!error.course || !!error.goalLevel;
      acc.errors.push(error);
      return acc;
    },
    { hasErrors: false, errors: [] }
  );
}

export function getKeyFromStreamUrl(videoUrl: string = '') {
  let videoKey;
  let checkCloudFront = videoUrl.split('cloudfront.net/');
  if (checkCloudFront.length > 1) {
    let videoKeyInclusion = checkCloudFront[1].split('.mp4?');
    if (videoKeyInclusion.length > 1) {
      videoKey = videoKeyInclusion[0];
    }
  } else {
    const streamsUri = videoUrl.split('stream=')[1] || '';
    const formattedStreamUri = streamsUri.toLowerCase() || '';
    const streams = formattedStreamUri.split('%3b') || [];
    videoKey = streams.filter((stream: any) => stream.includes('original'))[0] || '';
  }
  if(!videoKey) return '';
  return videoKey + '.mp4';
}
export function getKeyFromStreamUrlAudio(audioUrl: string = '') {
  let videoKey;
  let checkCloudFront = audioUrl.split('cloudfront.net/');
  if (checkCloudFront.length > 1) {
    let videoKeyInclusion = checkCloudFront[1].split('.mp3?');
    if (videoKeyInclusion.length > 1) {
      videoKey = videoKeyInclusion[0];
    } else if (videoKeyInclusion.length === 1) {
      videoKeyInclusion = checkCloudFront[1].split('.wav?');
      videoKey = videoKeyInclusion[0];
    }
  } else {
    const streamsUri = audioUrl.split('stream=')[1] || '';
    const formattedStreamUri = streamsUri.toLowerCase() || '';
    const streams = formattedStreamUri.split('%3b') || [];
    videoKey = streams.filter((stream: any) => stream.includes('original'))[0] || '';
  }
  if(!videoKey) return '';
  return videoKey + '.mp3';
}

export function getThumbnailSource(thumbnailKey: any) {
  let source = thumbnailKey;
  if (thumbnailKey && thumbnailKey.startsWith('videos/thumbnail')) {
    const { thumbnailBucketUrl } = config;
    source = `${thumbnailBucketUrl}/${source}`;
  } else {
    source = `data:image/png;base64, ${source}`;
  }
  return source
}

export function createStepForStepWiseSolution(stepNo = 1, isWeightageRequired = false) {
  const stepData: SolutionStep = {
    stepNo,
    solution: "",
  }
  if (isWeightageRequired) {
    stepData.weightage = 0;
  }
  return stepData;
}

export function validateFileExts(fileType: string, allowedExts: string[]) {
  const fileExt = (fileType.split('/') || [])[1];
  for (const allowedExt of allowedExts) {
    if (allowedExt === fileExt) {
      return true;
    }
  }
  return false;
}

export function validateImageDimensions(file: File, maxWidth: number, maxHeight: number) {
  const reader = new FileReader();

//Read the contents of Image File.
reader.readAsDataURL(file);

return new Promise((resolve, reject) => {
  reader.onload = function (e) {
  
    //Initiate the JavaScript Image object.
    const image = new Image();
  
    //Set the Base64 string return from FileReader as source.
    if(e.target) {

      // @ts-ignore
      image.src = e.target.result;
    }
  
    //Validate the File Height and Width.
    image.onload = function () {
      const height = image.naturalHeight;
      const width = image.naturalWidth;
      if (height > maxHeight || width > maxWidth) {
        return reject('Height/Width does not match the required criteria')
      }
      
      return resolve('Height and Width matches the required criteria');
    };
  };
})
}

export function extractExtension(url: string) {
  return url.slice((url.lastIndexOf(".") - 1 >>> 0) + 2);
}

export function extractFileNameAndExtension(name: string) {
  const splitted = name.split(".");
  const extension = splitted[splitted.length - 1];
  const fileName = splitted.slice(0, splitted.length - 1).join(".");
  return {fileName, extension};
}

export function scrollIntoView(elementId: string) {
  let element = null;
  try {
    element = document.querySelector(`#${elementId}`);
  } catch { }
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

export function getSyllabusRenderValue(question: any) {
  const {
    syllabus: { subjects },
  } = question;
  const data = subjects.reduce((acc: string[], subject: any) => {
    const { checked: subjectCheck, subSubjects, subjectId } = subject;
    if (!subjectId) {
      return acc;
    }
    if (subjectCheck || subjectId.checked) {
      acc.push(subjectId.name);
      return acc;
    }
    for (let subSubject of subSubjects) {
      const { checked: subSubjectCheck, chapters, subSubjectId } = subSubject;
      if (!subSubjectId) {
        continue;
      }
      if (subSubjectId.checked || subSubjectCheck) {
        acc.push(subSubjectId.name);
        continue;
      }
      for (let chapter of chapters) {
        const { checked: chapterCheck, concepts, chapterId } = chapter;
        if (!chapterId) {
          return "";
        }
        if (chapterId.checked || chapterCheck) {
          acc.push(chapterId.name);
          continue;
        }
        for (let concept of concepts) {
          const { checked: conceptCheck, conceptId } = concept;
          if (!conceptId) {
            return "";
          }
          if (conceptId.checked || conceptCheck) {
            acc.push(conceptId.name);
            continue;
          }
        }
      }
    }
    return acc;
  }, []);
  return data.join(", ");
};

export const iconsForSubjects: { [subjectName: string]: string } = {
  physics: '/assets/svg/myLibrary/physics.svg',
  chemistry: '/assets/svg/myLibrary/chemistry.svg',
  mathematics: '/assets/svg/myLibrary/mathematics.svg',
  english: '/assets/svg/myLibrary/english.svg',
  hindi: '/assets/svg/myLibrary/hindi.svg',
  socialscience: '/assets/svg/myLibrary/socialscience.svg',
  mat: '/assets/svg/myLibrary/mat.svg',
  logicalreasoning: '/assets/svg/myLibrary/logicalreasoning.svg',
  biology: '/assets/svg/myLibrary/biology.svg',
  generalknowledge: '/assets/svg/myLibrary/generalknowledge.svg',
}

export const fiitJeeMasterClientId: string = "5e832d495540b200e53ae432";
// Content Tags only for FIITJEE clients shows in filter modal of testBuilder 
export const concepts = ["Singular Concept",
  "Multi Concept",
  "Multi Subject"];

export const pattern: any = {
  "Subjective": ["Very Short Answer",
    "Short Answer",
    "Long Answer"],
  "Objective": ["Fill in the blanks",
    "True/False",
    "Multiple Choice-Single Correct",
    "Multiple Choice- Multiple Correct",
    "Comprehension based",
    "Linked Comprehension",
    "Assertion-Reasoning",
    "Match the following- Two Columns",
    "Match the following- Three Columns",
    "Match List ",
    "Numerical Based with single digit answer 0 to 9",
    "Numerical Based with decimal type answer"]
};
export const skill = ["Direct Application of Formula",
  "Formula based but requiring concept knowledge and calculations",
  "InDepth conceptual understanding",
  "Analytical",
  "Intuitive",
  "Ultimate requiring multiconcepts/ multisubjects",
  "Spatial /Pictorial and 3-D expertise",
  "Verbal ",
  "Language Comprehension",
  "Puzzles/Riddles"];

 export  function getRandomColor(number:number) {
    const hue = number * 137.508; // use golden angle approximation
    return `hsl(${hue},50%,75%)`;
  }

export function getNumberOrEmtpyString(value: any) {

  if (value === undefined || value === null) {
    return '';
  }

  return value;
}

export function getNumberFromString(string: string) {

  const numberList = string.trim().match(/\d/g);

  if (!numberList) {
    return '';
  }
  const value = numberList.join('')

  return Number.parseInt(value);
}
export function getTextLengthWithoutSpaces(value: string) {
  const length = value.replace(/\s+/g, '').length;
  return length;
}  

export function debounce(callback: Function, delay: number) {
  let timeout: any;
  return function (...args: any) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
export function createDeepCopy(data: any) {
  return JSON.parse(JSON.stringify(data));
}

export function getPropertyValue(objectData: any, propertyString: string, defaultValue?: any) {
  const propertyList = propertyString.split('.');
  let value = objectData;

  for (let property of propertyList) {
    value = value && value[property];
  }

  return value || defaultValue;
}

export function getUserType(userType: string) {
  const acl = JSON.parse(localStorage.getItem('patmy') || '{}');
  const activeUserType = getPropertyValue(acl, 'authenticatedUser.userType');
  return (userType === activeUserType);
}

export function getTimerStateForIdealTime(state: number) {
  let durationType = 'sec';
  switch (state) {
    case 2:
      durationType = 'min';
      break;
    case 3:
      durationType = 'hour'
      break;
  }
  return durationType
}


export function getQueryParams(pathUrl: string, params: string) {
  const queryParams = new URLSearchParams(pathUrl);
  const paramsValue = queryParams.get(params);
  return paramsValue;
}
export function formatDateToMonthTime(date: string) {
  if (!date) {
    return '';
  }
  const options:any = { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
  const dateObject = new Date(date);
  const dateString = dateObject.toLocaleDateString('en-US', options);

  return dateString;
}

export function isEmpty(object: any) {
  return !Object.keys(object || {}).length;
}

export function getCharacterCount(words: string = '') {
  const regexForSpaceRemove = /\s/g;
  return words.replace(regexForSpaceRemove, '').length;
}

export function formatDateToDayMonthYear(dateString: string = '') {
  const newDate = new Date(dateString);
  const options: any = { year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = newDate.toLocaleDateString('en-US', options);
  return formattedDate;
}

export function formatDateToDayMonthYearGB(date: string = '') {
  const dateToFormat = new Date(date);
  const options: any = { day: 'numeric', month: 'long', year: 'numeric' };
  return dateToFormat.toLocaleDateString('en-GB', options);
}

export function convertDateToHHMM(dateString = '') {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= DATE_PARAMS.TWELVE_HOURS ? DATE_PARAMS.PM : DATE_PARAMS.AM;
  const formattedHours = hours % DATE_PARAMS.TWELVE_HOURS === 0 ? DATE_PARAMS.TWELVE_HOURS : hours % DATE_PARAMS.TWELVE_HOURS;
  const formattedMinutes = minutes < DATE_PARAMS.TEN ? DATE_PARAMS.PADDED_ZERO + minutes : minutes;
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

export function convertDaysToReadableFormat(days: number) {
  const year = Math.floor(days / 365);
  let formattedDate = '';
  if (!year) {
    formattedDate = `${days} days`;
  } else if (year === 1) {
    formattedDate = `${year} year`;
  } else {
    formattedDate = `${year} years`
  }
  return formattedDate;
} 

export function updateQueryParams(key: string, value: string) {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState(null, '', url.toString());
}

export function getLabel(isStartDateChanges: boolean, isTest: boolean) {
  if (isStartDateChanges) {
      return isTest ? CHANGE_LABEL.START_DATE.TEST_LABEL : CHANGE_LABEL.START_DATE.LABEL;
  }
  return isTest ? CHANGE_LABEL.END_DATE.TEST_LABEL : CHANGE_LABEL.END_DATE.LABEL;
}

export function checkForTeacherUser(content: any, allContent?: boolean) {
  const questionContent = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION;
  const userData = JSON.parse(localStorage.getItem('patmy') || '{}');
  const teacherUser = [];
  const studentUser = getUserType(USER_TYPE.STUDENT);
  teacherUser.push(getPropertyValue(userData, 'authenticatedUser.isTeacher'));
  teacherUser.push(studentUser);
  teacherUser.push(getPropertyValue(content, 'isCreatorTeacher'));

  const additionalFeature = getPropertyValue(userData, 'authenticatedUser.additionalFunctionalities', []);
  const teacherFeature = [];
  teacherFeature.push(questionContent || allContent);
  teacherFeature.push(teacherUser.some(value => value));
  teacherFeature.push(studentUser || additionalFeature.includes(ADDITIONAL_FUNCTIONALITY.CONTENT_VALIDATION));

  return teacherFeature.every(enableFeature=>enableFeature);
}

export function checkCreateContentAccess() {
  const modulesAcess = [...PERMISSION_QUESTION_CONTENT_TYPES, ...PERMISSION_TEST_CONTENT_TYPES, PERMISSION_CONTENT_TYPES.STUDY_MATERIAL].filter((content) => ACLService.checkModulePermission(content, USER_RIGHTS.CREATE));
  return !!modulesAcess.length;
}

export const getContentBucketName = (content: ContentData) => {
  if (!content) return '';
  const contentSpecialPurpose = CONTENT_SECTION_TYPES.filter(section => (content.specialPurposes || []).includes(section.value));
  return contentSpecialPurpose.length ? contentSpecialPurpose[0].title : CONTENT_SECTION_TYPES[0].title;
}

export const checkForAuthor = (content: ContentData) => {
  if (!content) return false;
  const questionAuthorId = _.get(content, 'aclMetaData.createdBy.id', {});
  if (questionAuthorId && questionAuthorId.id) {
      return questionAuthorId.id === ACLService.getUserDetailsFromStorage().authenticatedUser.id;
  }

  return false;
}

export function getSectionLevelDisplayName(sectionKey: string) {
  return (TEST_TEMPLATE_CONFIG.SECTION_LEVEL.find(section => section.key === sectionKey) || { name: sectionKey }).name;
}

export function getMasterTestTypeDisplayName(masterTestKey: string) {
  return (TEST_TEMPLATE_CONFIG.MASTER_TEST_TYPE.find(masterTest => masterTest.key === masterTestKey) || { name: masterTestKey }).name;
}